/**
 * ColumnProgressIndicator Component
 * 
 * Mini progress bar shown under column headers in CustomRoundModal
 * Indicates column status: todo (gray), in-progress (yellow), completed (green)
 * 
 * Visual states:
 * - todo: Empty bar (0%) - user hasn't started this step
 * - inProgress: Half-filled yellow bar (50%) - user is working on this step
 * - completed: Full green bar (100%) - step is complete
 */

import React from "react";
import { PROGRESS_INDICATOR_STYLES, ColumnStatus } from "../constants";

interface ColumnProgressIndicatorProps {
  status: ColumnStatus;
}

const ColumnProgressIndicator: React.FC<ColumnProgressIndicatorProps> = ({ status }) => {
  const statusStyle = PROGRESS_INDICATOR_STYLES[status];
  
  return (
    <div style={PROGRESS_INDICATOR_STYLES.container}>
      <div 
        style={{
          ...PROGRESS_INDICATOR_STYLES.bar,
          ...statusStyle,
        }} 
      />
    </div>
  );
};

export default ColumnProgressIndicator;

